import React, { useRef, useEffect } from 'react';
import "./styles.css";
import { createComponent } from "../../../components/FormArea/FormContent";
import { getBusinessControls } from '../../../components/oro-module/commonFunctions';


const useOutsideAlerter = (ref, cur) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        cur.liftGlobalState({ name: "businessControlOpen" }, false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}


const BusinessControls = (props) => {



  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props);



  let { currentPage, formElements, businessControlOpen, wizard, grid, theme, pageData } = props.parentState;
  let filter = formElements[currentPage].filter;
  let allc = getBusinessControls(filter, pageData);
  return (
    <div>
      {businessControlOpen &&
        <div
          ref={wrapperRef}
          className="custom-popover" id="business-controls">
          <div className="col-sm-12" style={{ padding: 2 }}>
            <div className="controlDesc">
              {businessControlOpen == 'basic' ? 'Basic' : businessControlOpen == 'advance' ? "Advance" : "More"} Controls
            </div>
            {/* Find the controls tagged for this page */}

            {businessControlOpen == 'basic' && createComponent({ allc: allc['basic'], selectedFormTab: "", wizard, grid, current: { props }, theme, showtag: true })
            }

            {businessControlOpen == 'advance' && createComponent({ allc: allc['advance'], selectedFormTab: "", wizard, grid, current: { props }, theme, showtag: true })
            }

            {businessControlOpen == 'more' && createComponent({ allc: allc['more'], selectedFormTab: "", wizard, grid, current: { props }, theme, showtag: true })
            }
          </div>

        </div>
      }
    </div>
  );
}

export default BusinessControls;